import { get, post, put } from './requests'

export const getAudience = ({ id }) => get(['audiences/'], { transformPayload: false }, { id })

export const getReports = ({ name, size, taxonomy, id, geo }) =>
  get(
    ['report'],
    { transformPayload: false },
    {
      audience_name: name,
      audience_size: size,
      audience_taxonomy: taxonomy,
      id,
      insights_geo: geo,
    }
  )

// DEPRECATED:
// for AC and AB decks
export const getAudienceInsights = ({ id, geo }) =>
  get(['audiences', 'insights'], { transformPayload: false }, { id, geo })

// DEPRECATED:
// for AI decks
export const getTopicsInsights = ({ ids, geo, reportId }) =>
  post(
    ['topics', 'insights'],
    { transformPayload: false },
    { ids, insights_geo: geo, report_id: reportId }
  )

export const saveReport = ({
  audience_name,
  audience_size,
  audience_taxonomy,
  id,
  insights_geo,
  insights_version,
  report_name,
  slides,
  title,
  topics,
}) =>
  post(
    ['report'],
    { transformPayload: false },
    {
      audience_name,
      audience_size,
      audience_taxonomy,
      id,
      insights_geo,
      insights_version,
      report_name,
      slides,
      title,
      topics,
    }
  )

export const chooseSlides = ({ slides, audience_id, report_id }) =>
  put(
    ['report', 'slides'],
    { transformPayload: false },
    {
      slides,
      audience_id, // for AC and AB audiences
      report_id, // for AI audiences
    }
  )
